/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import 'echarts/lib/chart/pie';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/grid';
import 'echarts/lib/component/dataZoom';
import echarts from 'echarts/lib/echarts';
import merge from 'lodash/merge';
import isString from 'lodash/isString';
import { connect } from 'react-redux';
import styles from './styles.scss';


const defaultProps = {
  legend: [],
  title: '',
};

const defaultTitle = {
  textStyle: {
    fontSize: 14,
    fontWeight: 300,
  },
  textBaseline: 'bottom',
};

const propTypes = {
  series: React.PropTypes.array.isRequired,
  title: React.PropTypes.any,
  legend: React.PropTypes.any,
};

const defaultSeries = {
  label: {
    normal: {
      textStyle: {
        fontWeight: 300,
      },
    },
  },
  radius: [0, '60%'],
};

class PieChart extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      series: props.series,
      legend: props.legend,
    };
  }

  componentDidMount() {
    this.echart = this.initChart();
    $(this.chartRef).height($(this.wrapperRef).height());
    this.echart.resize();
    $(window).resize(this.resizeChart);
  }

  componentWillReceiveProps(nextProps) {
    const { series, legend } = nextProps;
    if (series !== this.props.series) {
      this.setState({
        series: nextProps.series,
        legend: nextProps.legend,
      });
      this.updateChart(series, legend);
    }
    this.resizeChart();
  }

  componentWillUnmount() {
    echarts.dispose($(this.chartRef));
    $(window).off('resize', this.resizeChart);
  }

  resizeChart() {
    const width = $(this.wrapperRef).width();
    const height = $(this.wrapperRef).height();
    if (height !== this.height) {
      $(this.chartRef).height(height);
      if (this.echart) {
        this.echart.resize();
      }
    } else if (width !== this.width) {
      if (this.echart) {
        this.echart.resize();
      }
    }
    this.width = width;
    this.height = height;
  }

  updateChart(nextSeries, nextLegend) {
    const series = nextSeries.map(s => ({ ...s, type: 'pie' }));
    const legend = nextLegend || [];
    const option = { series, legend };
    this.echart.setOption(option);
    this.echart.resize();
  }

  initChart() {
    const echart = echarts.init(this.chartRef);
    const series = this.state.series.map(s => merge({},
      defaultSeries,
      {
        ...s,
        type: 'pie',
      },
    ));

    const { legend } = this.props;
    let { title } = this.props;
    if (isString(title)) {
      title = {
        ...defaultTitle,
        text: title,
      };
    }
    const option = {
      title,
      legend,
      series,
      tooltip: {
        trigger: 'item',
        formatter: '{b} : {c} ({d}%)',
      },
      color: PieChart.colors,
    };
    echart.setOption(option);
    return echart;
  }

  render() {
    return (
      <div
        className={styles.wrapper}
        ref={(ref) => { this.wrapperRef = ref; }}
      >
        <div className={styles.chart} ref={(ref) => { this.chartRef = ref; }} />
      </div>
    );
  }
}

PieChart.colors = [
  '#22A7F0',
  '#00B16A',
  '#F7CA18',
  '#F9690E',
  '#EF4836',
  '#DB0A5B',
  '#663399',
  '#BF55EC',
  '#446CB3',
  '#336E7B',
  '#1BBC9B',
];
PieChart.propTypes = propTypes;
PieChart.defaultProps = defaultProps;

export default connect(
  state => ({
    collapsed: state.sidebar.collapsed,
  }),
)(PieChart);




// WEBPACK FOOTER //
// ./src/containers/Network/coms/GatewayView/coms/PieChart/index.jsx